// 세금계산서 — 팝빌 조회 탭 (매출 / 매입 수신분). admin 전용 읽기 화면.
// TaxInvoicePage 가 500줄 규칙(autodoc/CLAUDE.md)을 넘겨 조회 두 탭만 분리.
// 상태는 페이지가 소유하고 여기는 렌더만 한다 (props 6개).
import React from 'react';

function TaxInvoicePopbillLists({ tab, list, listLoading, loadList, receivedList, receivedLoading, loadReceived, openPdf }) {
  return (
    <>
        {tab === 'list' && (
          <div className="card" style={{ padding: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ fontSize: 14, margin: 0, color: '#1B3A5C' }}>{'\uBC1C\uD589 \uBAA9\uB85D (\uCD5C\uADFC 3\uAC1C\uC6D4)'}</h3>
              <button onClick={loadList} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #d0d5dd', background: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'\uC0C8\uB85C\uACE0\uCE68'}</button>
            </div>
            {listLoading ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uB85C\uB529 \uC911...'}</div>
            ) : list.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uBC1C\uD589\uB41C \uC138\uAE08\uACC4\uC0B0\uC11C\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4'}</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['\uBC1C\uD589\uC77C', '\uAD00\uB9AC\uBC88\uD638', '\uACF5\uAE09\uBC1B\uB294\uC790', '\uD569\uACC4\uAE08\uC561', '\uC0C1\uD0DC', 'PDF'].map(function (h, i) {
                      return <th key={i} style={{ padding: '10px 8px', borderBottom: '2px solid #e2e8f0', textAlign: 'left', fontWeight: 700, color: '#475569' }}>{h}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {list.map(function (inv, idx) {
                    var stColor = inv.stateCode >= 300 ? '#16a34a' : inv.stateCode >= 200 ? '#d97706' : '#94a3b8';
                    return (
                      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '10px 8px' }}>{inv.writeDate || '-'}</td>
                        <td style={{ padding: '10px 8px', fontFamily: 'monospace', fontSize: 11 }}>{inv.invoicerMgtKey || inv.itemKey || '-'}</td>
                        <td style={{ padding: '10px 8px' }}>{inv.invoiceeCorpName || '-'}</td>
                        <td style={{ padding: '10px 8px', fontWeight: 600 }}>{(parseInt(inv.totalAmount) || 0).toLocaleString()}</td>
                        <td style={{ padding: '10px 8px' }}>
                          <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700, background: stColor === '#16a34a' ? '#dcfce7' : stColor === '#d97706' ? '#fef3c7' : '#f1f5f9', color: stColor }}>
                            {inv.stateCode >= 300 ? '\uBC1C\uD589\uC644\uB8CC' : inv.stateCode >= 200 ? '\uC804\uC1A1\uC911' : '\uB300\uAE30'}
                          </span>
                        </td>
                        <td style={{ padding: '10px 8px' }}>
                          <button onClick={function () { openPdf(inv.itemKey); }} style={{ padding: '4px 10px', borderRadius: 4, border: '1px solid #ef4444', background: '#fff', color: '#ef4444', fontSize: 10, fontWeight: 600, cursor: 'pointer' }}>PDF</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}

        {tab === 'received' && (
          <div className="card" style={{ padding: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ fontSize: 14, margin: 0, color: '#16a34a' }}>{'\uD83D\uDCE5 \uB9E4\uC785 \uC138\uAE08\uACC4\uC0B0\uC11C (\uCD5C\uADFC 3\uAC1C\uC6D4)'}</h3>
              <button onClick={loadReceived} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #d0d5dd', background: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'\uC0C8\uB85C\uACE0\uCE68'}</button>
            </div>
            {receivedLoading ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uB85C\uB529 \uC911...'}</div>
            ) : receivedList.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uC218\uCDE8\uD55C \uC138\uAE08\uACC4\uC0B0\uC11C\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4'}</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: '#f0fdf4' }}>
                    {['\uBC1C\uD589\uC77C', '\uACF5\uAE09\uC790', '\uD488\uBAA9', '\uD569\uACC4\uAE08\uC561', '\uC0C1\uD0DC', 'PDF'].map(function (h, i) {
                      return <th key={i} style={{ padding: '10px 8px', borderBottom: '2px solid #bbf7d0', textAlign: 'left', fontWeight: 700, color: '#166534' }}>{h}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {receivedList.map(function (inv, idx) {
                    var stColor = inv.stateCode >= 300 ? '#16a34a' : inv.stateCode >= 200 ? '#d97706' : '#94a3b8';
                    return (
                      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '10px 8px' }}>{inv.writeDate || '-'}</td>
                        <td style={{ padding: '10px 8px' }}>{inv.invoicerCorpName || '-'}</td>
                        <td style={{ padding: '10px 8px', fontSize: 11 }}>{(inv.detailList && inv.detailList[0] && inv.detailList[0].itemName) || inv.itemName || '-'}</td>
                        <td style={{ padding: '10px 8px', fontWeight: 600 }}>{(parseInt(inv.totalAmount) || 0).toLocaleString()}</td>
                        <td style={{ padding: '10px 8px' }}>
                          <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700, background: stColor === '#16a34a' ? '#dcfce7' : stColor === '#d97706' ? '#fef3c7' : '#f1f5f9', color: stColor }}>
                            {inv.stateCode >= 300 ? '\uBC1C\uD589\uC644\uB8CC' : inv.stateCode >= 200 ? '\uC804\uC1A1\uC911' : '\uB300\uAE30'}
                          </span>
                        </td>
                        <td style={{ padding: '10px 8px' }}>
                          <button onClick={function () { openPdf(inv.itemKey); }} style={{ padding: '4px 10px', borderRadius: 4, border: '1px solid #16a34a', background: '#fff', color: '#16a34a', fontSize: 10, fontWeight: 600, cursor: 'pointer' }}>PDF</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}
    </>
  );
}

export default TaxInvoicePopbillLists;
